import { TestIds } from "constants/Tests/TestIds";
import { JSX } from "react";
import ShortcutGridElement from "./ShortcutGridElement";
import { Shortcut } from "./Shortcuts";

const createShortcuts = (shortcuts: Shortcut[]): JSX.Element[] => {
  return shortcuts.map(shortcut => (
    <ShortcutGridElement
      data-testid={TestIds.SHORTUT}
      key={shortcut.id}
      id={shortcut.id}
      name={shortcut.label.description}
      shortcutLocation={shortcut.label.etiquetteLocation}
    />
  ));
};
export default createShortcuts;
